module.exports = __webpack_public_path__ + "static/media/landing.997f3ea5.png";